var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useEffect, useState } from "react";
import { useUuid } from "../../../common/hooks/useUuid";
import { useToolbarContentItemIdStore } from "../../hooks/useToolbarContentItemIdStore";
import { useToolbarContainerItemContentStore } from "../../hooks/useToolbarContainerItemContentStore";
import { ToolbarButtonStatefulControl } from "./toolbar-button-stateful-control";
/**
 * Component used to render the items in container below the toolbar.
 * This component is used by the ToolbarButtonStateful component to render active content.
 */
export var ToolbarButtonContainer = forwardRef(function (_a, ref) {
    var _b;
    var _c = _a.disabled, disabled = _c === void 0 ? false : _c, onClick = _a.onClick, props = __rest(_a, ["disabled", "onClick"]);
    var uuid = useUuid([]);
    var id = (_b = props.id) !== null && _b !== void 0 ? _b : uuid;
    var _d = useState(false), isExpanded = _d[0], setIsExpanded = _d[1];
    var _e = useToolbarContentItemIdStore(), expandedItemId = _e.expandedItemId, setExpandedItemId = _e.setExpandedItemId, clearExpandedItemId = _e.clearExpandedItemId;
    useEffect(function () {
        setIsExpanded(id === expandedItemId);
    }, [id, expandedItemId]);
    var setContent = useToolbarContainerItemContentStore(function (state) { return state.setContent; });
    useEffect(function () {
        setContent(id, props.ActiveStateContent);
    }, [id, props.ActiveStateContent]);
    return (_jsx(ToolbarButtonStatefulControl, __assign({}, props, { disabled: disabled, isSelected: isExpanded, onClick: function () {
            if (isExpanded) {
                clearExpandedItemId();
            }
            else {
                setExpandedItemId(id);
            }
            onClick && onClick();
        } })));
});
// react/display-name: Component definition is missing display name
ToolbarButtonContainer.displayName = "ToolbarButtonContainer";
